import { useState, useEffect } from "react";
import '../styles/CategoryDropdown.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export function CategoryDropdown({ selectedNames, onChange, onFetched }) {
  const [categories, setCategories] = useState([]);
  const [internalSelected, setInternalSelected] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🟠 Pobieranie kategorii
  useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/events/categories/`);
      const data = await res.json();
      setCategories(data);
      onFetched?.(data);
    } catch (err) {
      console.error("Błąd pobierania kategorii:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchCategories();
}, []);


  useEffect(() => {
  if (categories.length === 0) return;

  const allNames = categories.map((c) => c.name);

  // if (!selectedNames || selectedNames.length === 0) {
  //   // domyślnie zaznacz wszystkie
  //   // setInternalSelected(allNames);
  //   onChange?.(allNames);
  // } else {
  //   // użyj tego, co przyszło z góry (np. z URL-a)
  //   setInternalSelected(selectedNames);
  // }
  if (selectedNames) {
    setInternalSelected(selectedNames);
  }
}, [selectedNames, categories, onChange]);

  const allSelected =
    categories.length > 0 && internalSelected.length === categories.length;

  const toggleCategory = (name) => {
    setInternalSelected((prev) => {
      let next;
      if (prev.includes(name)) {
        next = prev.filter((n) => n !== name);
      } else {
        next = [...prev, name];
      }
      onChange?.(next);
      return next;
    });
  };

  const toggleAll = () => {
    setInternalSelected((prev) => {
      let next;
      if (allSelected) {
        next = [];
      } else {
        next = categories.map((c) => c.name);
      }
      onChange?.(next);
      return next;
    });
  };

  return (
      <div className="dropdown category-dropdown">
    <button
      className="category-dropdown-toggle"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      disabled={loading}
    >
      <span className="category-dropdown-toggle__icon">
        <i className="bi bi-tag" />
      </span>
      <span className="category-dropdown-toggle__label">
        {loading
          ? "Ładowanie..."
          : allSelected
          ? "Wszystkie kategorie"
          : internalSelected.length > 0
          ? `Kategorie (${internalSelected.length})`
          : "Kategorie"}
      </span>
      <span className="category-dropdown-toggle__chevron">
        <i className="bi bi-chevron-down" />
      </span>
    </button>

      <ul className="dropdown-menu p-2" style={{ minWidth: "260px" }}>
        <li className="d-flex justify-content-between align-items-center mb-2 px-1">
          <strong>Kategorie</strong>
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            onClick={toggleAll}
            disabled={categories.length === 0}
          >
            {allSelected ? "Odznacz wszystko" : "Zaznacz wszystko"}
          </button>
        </li>

        <li><hr className="dropdown-divider" /></li>

        {categories.map((cat) => (
          <li key={cat.id}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id={`cat-${cat.id}`}
                checked={internalSelected.includes(cat.name)}
                onChange={() => toggleCategory(cat.name)}
              />
              <label className="form-check-label" htmlFor={`cat-${cat.id}`}>
                {cat.name}{" "}
                <span className="text-muted small">
                  ({cat.event_count})
                </span>
              </label>
            </div>
          </li>
        ))}

        {!loading && categories.length === 0 && (
          <li className="px-2 text-muted small">Brak kategorii</li>
        )}
      </ul>
    </div>
  );
}
